import { t } from '@lingui/core/macro';
import { type ReactNode } from 'react';

import { Text } from '@/components/typography';

import { Spinner } from '../Spinner';

type Props = {
  text?: ReactNode;
};

const PageSpinner = ({ text = t`Loading data` }: Props) => {
  return (
    <div className="pointer-events-none fixed left-0 z-10 flex w-screen flex-col items-center gap-4">
      <Spinner variant="spoke" size="lg" />
      <Text variant="subhead">{text}</Text>
    </div>
  );
};

export default PageSpinner;
